import { useState } from 'react'
import layoutBgImg from '../../Images/layout/others.jpg'
import Layout from '../../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import Physical from '../../Component/auth/physical'
import Juridical from '../../Component/auth/juridical'
// import { Navigate } from 'react-router-dom'
// import { Post } from '../../api/services/api_helpers'
// import { Context } from '../../Store/context'
import GlobalLayout from '../../Component/layout/global-layout'

const Registration = () => {
  const { t } = useTranslation()
  const [formType, setFormType] = useState('physical');
  // const [isLoading, setIsLoading] = useState(false);
  // const { showError } = useContext(Context);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await Post()
  //     let token = res.data.token;
  //     localStorage.clear();
  //     localStorage.setItem('token', token);
  //     Navigate('/home');
  //     window.location.href = '/home';
  //   }
  //   catch (error) {
  //     showError(error?.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  return (
    <GlobalLayout
      title={`${t('registration')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords=""
    >
      <div className='mb-20'>
        <Layout
          title={t('registration')}
          layoutBgImg={layoutBgImg}
        />
        <div className='flex justify-center w-full'>
          <div className='bg-white p-4 xl:p-8 mt-8 xl:w-[50%] 
                        dark:bg-dark-box w-[90%]'>
            <h1 className='text-center font-bold 
                         mb-1 text-4xl dark:text-white'>
              {t('registration')}
            </h1>
            <p className='text-center text-text text-sm
                        dark:text-dark-text'>
              {t('please_registration')}
            </p>

            {/* Juridical and Physical buttons */}
            <div className="flex space-x-2 w-full mt-8
                          justify-between lg:justify-start">
              <button
                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max
                          ${formType === 'physical' ? 'bg-primary text-white'
                    : 'bg-secondary text-black'}`}
                onClick={() => setFormType('physical')}
              >
                {t('physical')}
              </button>
              <button
                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max
                          ${formType === 'juridic' ? 'bg-primary text-white'
                    : 'bg-secondary text-black'}`}
                onClick={() => setFormType('juridic')}
              >
                {t('juridical')}
              </button>
            </div>

            {formType === 'physical' && <Physical />}
            {formType === 'juridic' && <Juridical />}
          </div>
        </div>
      </div>
    </GlobalLayout>
  )
}

export default Registration